/**
 * The constant will be used if no data is provied by the API.
 */
export const NO_DATA_FALLBACK = '-';

/**
 * The constant will be used to separate multiple values inside Order History Filter.
 */
export const MULTI_VALUE_SEPARATOR = ', ';
